import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material'
import { Select } from '@center/ui-kit'
import { 
  DropdownIndicator, 
  ValueContainer, 
  CustomOption, 
  CustomControl, 
  getSelectStyles 
} from 'components/global/Selects/SingleSelectStyles'

interface QueuesProps {
  names: string[]
  value?: string
  onChange: (value: string) => void
}

const Queues = ({ names, value, onChange }: QueuesProps) => {
  const { t } = useTranslation()
  const theme = useTheme()
  
  const options = useMemo(() => {
    const options = value ? [{label: t('voip.filter.queue_all'), value: null, id: 'all'}] : []
    return [...options, ...names.map(name => ({label: name, value: name, id: name}))]
  }, [names, value, t])
  
  return (
    <Select
      placeholder={value || t('voip.filter.queue')}
      value={value ? {label: value, value, id: value} : null}
      onChange={({value}) => onChange(value)}
      options={options}
      mainField={'label'}
      components={{ 
        Option: CustomOption,
        DropdownIndicator,
        ValueContainer,
        Control: CustomControl,
        IndicatorSeparator: () => null,
        ClearIndicator: () => null
      }}
      menuPortalTarget={document.body}
      styles={getSelectStyles(theme)}
    />
  )
}

export default Queues
